window.HARVARD = window.HARVARD || {};

HARVARD.config = {
  dateFormat: 'MM/DD/YYYY',
  datetimeFormat: 'MM/DD/YYYY h:mm a',
  userType: void 0,
  userId: void 0
};

export default HARVARD;